<template>
  <!--
    Simple loading spinner. Show or hide using v-if on the parent component.
  -->
  <div class="loading-spinner-container">
    <div class="spinner"></div>
    <div>Loading...</div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
}
</script>

<style lang="scss">
@import '@/scss/vars.scss';

.loading-spinner-container {
  padding-top: 1rem;
  position: relative;
  z-index: 50;
  min-height: 6.5rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.8rem;

  > div {
    padding: 0.25rem 0;
  }

  .spinner {
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 3px solid rgba(216, 216, 216, 0.888);
    border-radius: 50%;
    border-top-color: $main-blue;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
  }
  @keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  @-webkit-keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
}
</style>
